import React, { useCallback, useReducer, createContext, useMemo } from 'react';

import reducer, { INIT_STATE, setMapBounds, setMainMarker, setClear } from './POIMapReducer';

const POIMapContext = createContext();

function POIMapContextProvider(props) {
  const [state, dispatch] = useReducer(reducer, INIT_STATE);

  const centerMap = useCallback((bounds) => {
    dispatch(setMapBounds(bounds));
  }, []);

  const createMainMarker = useCallback((marker) => {
    dispatch(setMainMarker(marker));
  }, []);

  const clearMap = useCallback((marker) => {
    dispatch(setClear(marker));
  }, []);

  const mapBounds = useMemo(() => state.mapBounds, [state.mapBounds]);
  const mainMarker = useMemo(() => state.mainMarker, [state.mainMarker]);

  const contextValue = {
    mapBounds,
    mainMarker,
    centerMap,
    createMainMarker,
    clearMap,
  };

  return <POIMapContext.Provider value={contextValue}>{props.children}</POIMapContext.Provider>;
}

export { POIMapContext, POIMapContextProvider };
